import { Swiper } from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';
import {classInstance} from '@/shared/helpers/helpers';

export class MainHeader {
	private readonly element: HTMLElement;
	private sliderElement: HTMLElement;
	private buttonPrev: HTMLElement;
	private buttonNext: HTMLElement;
	private paginationElement: HTMLElement;
	private slider: Swiper;
	private sliderSettings = (): SwiperOptions => ({
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		navigation: {
			prevEl: this.buttonPrev,
			nextEl: this.buttonNext,
		},
		pagination: {
			el: this.paginationElement,
			type: 'progressbar',
		},
	});


	constructor(element) {
		if (!element) return;

		this.element = element;

		this.init();
	}

	public init = (): void => {
		this.sliderElement = this.element.querySelector('.main-header__slider');
		this.buttonPrev = this.element.querySelector('.slider-navigation__button--prev');
		this.buttonNext = this.element.querySelector('.slider-navigation__button--next');
		this.paginationElement = this.element.querySelector('.slider-navigation__pagination');
		this.slider = new Swiper(this.sliderElement, this.sliderSettings());
		classInstance.set(this.element, this);
	};

	public destroy = (): void => {
		classInstance.del(this, 'MainBanner');
		this.slider.destroy();
		this.sliderElement = null;
		this.buttonPrev = null;
		this.buttonNext = null;
		this.paginationElement = null;
		this.slider = null;
	};
}
